import { ApiRequestError } from './request-error';

/** Retry a transient read once, never an unchanged authorization/validation
 * failure. This does not alter permissions, error messages or manual refresh. */
export function shouldRetryReadQuery(failureCount: number, error: unknown): boolean {
  if (!Number.isSafeInteger(failureCount) || failureCount < 0 || failureCount >= 1) return false;
  if (error instanceof Error && error.name === 'AbortError') return false;
  if (error instanceof DOMException && error.name === 'AbortError') return false;
  if (error instanceof ApiRequestError) return error.status === 408 || (error.status >= 500 && error.status <= 599);
  return true;
}

/** The shell's two authorization reads must survive a development API restart.
 * Keep a bounded recovery window; never retry a rejection or replay a write. */
export function shouldRetryAccessQuery(failureCount: number, error: unknown): boolean {
  return Number.isSafeInteger(failureCount) && failureCount >= 0 && failureCount < 24
    && shouldRetryReadQuery(0, error);
}

export function accessRetryDelay(attempt: number): number {
  return Math.min(1000 * 2 ** attempt, 5000);
}
